// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'forward';

export const Component = () => (
  <path d='M24.218 10.11 16.67 2.64c-.187-.094-.281-.14-.328-.14-.328 0-.469.185-.469.51v4.27c-4.077 0-7.593 1.345-10.546 4.036C2.375 14.008.734 17.581.5 21.99c0 .325.14.51.469.51a.496.496 0 0 0 .422-.232c1.64-2.505 3.89-4.548 6.75-6.079 2.812-1.531 5.39-2.274 7.734-2.274v4.27c0 .324.14.51.469.51.14 0 .234-.046.328-.14l7.547-7.1a.913.913 0 0 0 .281-.649.942.942 0 0 0-.281-.696h-.001Zm-.656.65-6.75 6.357v-4.13h-.938c-2.203 0-4.687.65-7.36 1.95-2.718 1.345-5.014 3.108-6.843 5.382.516-3.48 2.063-6.357 4.735-8.678 2.672-2.274 5.765-3.433 9.281-3.433h1.125V4.124l6.75 6.635v.001Z' />
);

export const viewBox = '0 0 25 25';
